var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 1.5a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5M3.228 17.353c1.776-1.885 4.163-3.02 6.772-3.02s4.996 1.136 6.772 3.02a1 1 0 0 0 1.456-1.372c-2.117-2.245-5.015-3.648-8.228-3.648s-6.111 1.403-8.228 3.648a1 1 0 0 0 1.456 1.372"
})));
SvgUserFilled.displayName = "SvgUserFilled";
export { SvgUserFilled as ReactComponent };
export default SvgUserFilled;